import {Platform} from 'react-native';
import Localized from 'src/constants/AppStrings';
import Settings from 'src/Settings';
import UIManager from '../../../../elements/ui/UIManager';

export interface FAQ {
  question: string;
  answer: string;
}

const faqConfig = {
  aramark: (): FAQ[] => [
    {
      question: Localized.Labels.faq_how_request_refund,
      answer: Localized.Labels.faq_how_request_refund_answer,
    },
    {
      question: Localized.Labels.faq_change_location_card,
      answer: Localized.Labels.redesign_change_location_ans,
    },
    {
      question: Localized.Labels.faq_auto_reload,
      answer: Localized.Labels.redesign_auto_reload_desc,
    },
    {
      question: Localized.Labels.faq_report_issue,
      answer: Localized.Labels.faq_report_issue_answer,
    },
    {
      question: Localized.Labels.faq_reward_point,
      answer: Localized.Labels.faq_reward_point_answer,
    },
    {
      question: Localized.Labels.faq_notification,
      answer: Localized.Labels.faq_notification_answer,
    },
  ],

  pay365: (): FAQ[] => [
    {
      question: Localized.Labels.faq_how_request_refund,
      answer: Localized.Labels.faq_how_request_refund_answer,
    },
    {
      question: Localized.Labels.faq_change_location_card,
      answer: Localized.Labels.redesign_change_location_ans,
    },
    {
      question: Localized.Labels.faq_auto_reload,
      answer: Localized.Labels.redesign_auto_reload_desc,
    },
    {
      question: Localized.Labels.faq_report_issue,
      answer: Localized.Labels.faq_report_issue_answer,
    },
    {
      question: Localized.Labels.faq_reward_point,
      answer: Localized.Labels.faq_reward_point_answer,
    },
    {
      question: Localized.Labels.faq_notification,
      answer: Localized.Labels.faq_notification_answer,
    },
  ],

  refive: (): FAQ[] => [
    {
      question: Localized.Labels.faq_how_request_refund,
      answer: Localized.Labels.faq_how_request_refund_answer_refive,
    },
    {
      question: Localized.Labels.faq_change_location_card,
      answer: Localized.Labels.redesign_change_location_ans,
    },
    {
      question: Localized.Labels.faq_auto_reload,
      answer: Localized.Labels.redesign_auto_reload_desc,
    },
    {
      question: Localized.Labels.faq_report_issue,
      answer: Localized.Labels.faq_report_issue_answer,
    },
    {
      question: Localized.Labels.faq_reward_point,
      answer: Localized.Labels.faq_reward_point_answer,
    },
    {
      question: Localized.Labels.faq_notification,
      answer: Localized.Labels.faq_notification_answer_refive,
    },
  ],

  canteen: (): FAQ[] => [
    {
      question: Localized.Labels.how_request_refund,
      answer: Localized.Labels.how_request_refund_answer_canteen,
    },
    {
      question: Localized.Labels.faq_change_location_card,
      answer: Localized.Labels.faq_change_location_card_answer,
    },
    {
      question: Localized.Labels.faq_auto_reload,
      answer: Localized.Labels.faq_auto_reload_answer_canteen,
    },
    {
      question: Localized.Labels.faq_scan_market_card,
      answer: Localized.Labels.faq_scan_market_card_answer,
    },
    {
      question: Localized.Labels.faq_report_issue,
      answer: Localized.Labels.faq_report_issue_answer,
    },
    {
      question: Localized.Labels.faq_reward_points,
      answer: Localized.Labels.faq_reward_points_answer,
    },
    {
      question: Localized.Labels.faq_no_notifications,
      answer: Localized.Labels.faq_no_notifications_answer_canteen,
    },
  ],

  additional: (): FAQ[] => [
    {
      question: Localized.Labels.faq_diff_balance,
      answer: Localized.Labels.faq_diff_balance_answer,
    },
    {
      question: Localized.Labels.faq_product_issue,
      answer: Localized.Labels.faq_product_issue_answer,
    },
  ],

  mobile: (): FAQ[] => [
    {
      question: Localized.Labels.faq_bad_scan,
      answer: Localized.Labels.formatString(
        Localized.Labels.faq_bad_scan_answer,
        Settings.appDisplayName,
      ) as string,
    },
    {
      question: Localized.Labels.faq_no_locations,
      answer: Localized.Labels.faq_no_locations_answer,
    },
  ],

  default: (): FAQ[] => {
    const appName = Settings.appDisplayName;
    const faqs: FAQ[] = [
      {
        question: Localized.Labels.formatString(
          Localized.Labels.faq_market_compatible,
          appName,
        ) as string,
        answer: Localized.Labels.formatString(
          Localized.Labels.faq_market_compatible_answer,
          appName,
        ) as string,
      },
      {
        question: Localized.Labels.faq_auto_reload,
        answer:
          Platform.select({
            web: Localized.Labels.faq_auto_reload_answer_web,
            default: Localized.Labels.faq_auto_reload_answer,
          }) || '',
      },
      {
        question: Localized.Labels.faq_no_notifications,
        answer:
          Platform.select({
            web: Localized.Labels.faq_no_notifications_answer_web,
            default: Localized.Labels.formatString(
              Localized.Labels.faq_no_notifications_answer,
              appName,
            ) as string,
          }) || '',
      },
    ];

    if (UIManager.showAllFAQs()) faqs.push(...faqConfig.additional());
    if (Platform.OS !== 'web') faqs.push(...faqConfig.mobile());

    return faqs;
  },
};

export default faqConfig;
